import { LowerBoundDateRangeLiteral } from './dateTimeHelpers';
import { DaAggregationThresholdConfig } from './modelHelpers';
import { valueof } from './typeHelpers';

export const ID_AIRPORT_ICON_LAYER = 'biod.map.airport.layer.icon';
export const ID_AIRPORT_RISK_LAYER = 'biod.map.airport.layer.risk';
export const ID_OUTBREAK_OUTLINE_LAYER = 'biod.map.outbreak.layer.outline';
export const ID_OUTBREAK_ICON_LAYER = 'biod.map.outbreak.layer.icon';
export const ID_OUTBREAK_RISK_LAYER = 'biod.map.outbreak.layer.risk';
export const ID_PROXIMITY_OUTLINE_LAYER = 'biod.map.proximity.layer.outline';
export const ID_PROXIMITY_PINS_LAYER = 'biod.map.proximity.layer.pins';

export const ID_AOI_COUNTY_LAYER = 'biod.map.aoi.layer.county';
export const ID_AOI_METRO_LAYER = 'biod.map.aoi.layer.metro';
export const ID_AOI_PROVINCE_LAYER = 'biod.map.aoi.layer.province';
export const ID_AOI_COUNTRY_LAYER = 'biod.map.aoi.layer.country';
export const ID_AOI_CITY_LAYER = 'biod.map.aoi.layer.pin';

export const Geoname = {
  GLOBAL_VIEW: 0,
};
export const SpeciesIdHuman = 1;

export const CookieKeys = {
  PREF_MAIN_PAGE: 'biod.pref.root',
  JWT: '_jid',
};

export const RouterLinksToRememberInPrefMainPage = ['/overview'];
export const RouteQueryParamStartDate = 'startDate';
export const MinTimeframeStartDate = '2019-01-01';
export const DefaultTimeframeStartDateType = valueof<LowerBoundDateRangeLiteral>('last-60-days');
export const MaxTimeframeStartDateType = valueof<LowerBoundDateRangeLiteral>('last-week');
export const DefaultExportToPngWidth = 2550;

export type LogLevel = 'fatal' | 'error' | 'warn' | 'info' | 'debug';

// Aggregation boundaries: how many days of data each bar represents
// LINK: https://bluedotglobal.atlassian.net/browse/PT-1502
export const AggregationThresholdsSpark: DaAggregationThresholdConfig = {
  threeday: 30,
  week: 90,
  month: 30 * 7,
};
// LINK: https://bluedotglobal.atlassian.net/browse/PT-1504
export const AggregationThresholdsDetails: DaAggregationThresholdConfig = {
  threeday: 90,
  week: 270,
  month: 630,
};
export const DiseaseActivityHistoryLoadCount = {
  initOrMoreLoads: 10,
  deepLinkDatePad: 6,
};
export const DefaultMaxUserLocations = 75;

export const DisableTRANSPAR = false;
export const NowrapDACardTooltipDaterange = false;
export const ShowTranspar2Mode = true;
export const ShowOutlookReports = false;
export const DisableNewSettingsRoutes = false;
export const DebugAdminFormikModals = false;

export const LocationIndexSearchCount = {
  countries: 3,
  provinces: 3,
  metroAreas: 5,
  counties: 5,
  cities: 5,
  airports: 5,
};
